// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.access-parent-row[data-v-22f19584] {\n  background: hsl(222, 77%, 95%);\n  font-weight: bold;\n}\n.access-parent-row.theme-dark[data-v-22f19584] {\n  background: hsl(222, 77%, 15%);\n}\n.sticky-header-table th[data-v-22f19584] {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: var(--background-color);\n  color: var(--bulma-box-color);\n}\n", ""]);
// Exports
module.exports = exports;
